import { render, staticRenderFns } from "./tab12-old.vue?vue&type=template&id=837aed6e&scoped=true&"
import script from "./tab12-old.vue?vue&type=script&lang=js&"
export * from "./tab12-old.vue?vue&type=script&lang=js&"
import style0 from "./tab12-old.vue?vue&type=style&index=0&id=837aed6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837aed6e",
  null
  
)

export default component.exports